import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropTypes from "prop-types";
import CustomPropTypes from "../utils/customPropTypes";
import ImageBlock from "../components/ImageBlock";
// import style from "../../scss/components/GenericCarousel";
// import AllProducts from "../../scss/components/Products/AllProducts";
import SafeHTML from "../components/SafeHTML";
import ProductCard from "../components/Products/ProductCard";

import AccessoriesIcon from "../../img/accessories.svg";
import DocumentsIcon from "../../img/documents.svg";

export default class GenericCarousel extends Component {
  static ControlTypes = {
    Default: "",
    Accessories: "accessories",
  };
  static defaultProps = {
    controlType: GenericCarousel.ControlTypes.Default,
  };
  static propTypes = {
    eyebrow: PropTypes.string,
    description: PropTypes.string,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        eyebrow: PropTypes.string,
        link: CustomPropTypes.Link,
        icon: CustomPropTypes.Image,
        title: PropTypes.string,
      })
    ),
    controlType: PropTypes.string,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLastSlide: false,
      isFirstSlide: true,
      isDocuments: false,
      accessoriesData: [],
      documentsData: [],
      activeOthers: "accessories",
      currentIndex: 0,
      isMobileView: false

    };
    this.sliderRef = React.createRef();

  }

  componentDidMount() {

    let isColorFlexL2 = window.location.pathname.includes("colorflex-l2");
    let endpoint = window.location.pathname.split('/').filter(Boolean).pop();

    if (isColorFlexL2 || endpoint === "benchtop-spectrophotometers" || endpoint === "portable-spectrophotometers" || endpoint === "in-line-in-process-spectrophotometers" || endpoint === "quality-control-software") {
      // this.setState({ isColorFlexL2Page: isColorFlexL2 });
      import("../../scss/components/GenericCarouselNew");
      import("../../scss/components/Products/AllProductsNew");
    }else{
      import("../../scss/components/GenericCarousel");
      import("../../scss/components/Products/AllProducts");
    }
    if (isColorFlexL2) {
    let isMobile = window.matchMedia("(max-width: 500px)").matches
    if(isMobile){
      this.setState({isMobileView: isMobile})
    }
    if (this.isAccessoryCtrl()) {
      this.setState({ accessoriesData: this.props.cards });
    } else {
      this.setState({ documentsData: this.props.cards });
    }


    if (!this.isAccessoryCtrl()) {
      let items = this.props.cards;

      setTimeout(()=>{
        let docItemsElement = document.getElementById("documentsCardList")
        if(docItemsElement){

          // this.getAccesoriesOrDocuments()

          const element = document.getElementById("documentsCardList")
          // .innerHTML = this.getAccesoriesOrDocuments();
          // .appendChild(this.getGenericDocumentCardList());
          ReactDOM.render(this.getAccesoriesOrDocuments(), element);
        }else{
          window.location.reload()
        }
      },20)
    }
    if(this.props.eyebrow == "what-in-the-box"){
      document.querySelector('section[data-component-type="Accessories"]')
      .setAttribute('data-component-type', 'WhatInTheBox');
    }
  }
  }

  getGenericDocumentCardList = () => {
    const {isMobileView} = this.state
    if( this.props.controlType === GenericCarousel.ControlTypes.Default){
    let items = this.props.cards;
    let self = this;

    let wrapper = document.createElement("div");
    wrapper.className = "container";
    wrapper.style.display = "flex";
    wrapper.style.alignItems = "center"; // Centering the buttons and cards vertically


    let container = document.createElement("div"); // Create a container to hold all items
    container.className = "documents-container";
    container.style.overflow = "hidden"; // Hide overflowing cards
    container.style.width = "500px";
    container.style.whiteSpace = "nowrap";
    container.style.gap= "32px";
    container.style.display = "flex";
    container.style.flexGrow = 1;
    container.style.padding = "20px";
    container.style.position = "relative";
    container.style.paddingLeft = "32px";
    container.style.paddingRight = "32px";
    // container.style.backgroundColor = "#FAFAFA";

    
    let scrollLeft = document.createElement("button")
    scrollLeft.className = "arrow-left doc-arrow button-arrow doc-left"
    scrollLeft.textContent = "❮"
    scrollLeft.disabled = true;
      scrollLeft.onclick = () => {
      const cardWidth = document.querySelector(".post-card").offsetWidth + 32;
      container.scrollBy({ left: -cardWidth, behavior: "smooth" }); // Scroll left by one card width 
      this.updateButtonStates(container);
    };

    let scrollRight = document.createElement("button")
    scrollRight.className = "arrow-right doc-arrow button-arrow doc-right"
    scrollRight.textContent = "❯";
    scrollRight.onclick = () => {

      const cardWidth = document.querySelector(".post-card").offsetWidth + 32;
      container.scrollBy({ left: cardWidth, behavior: "smooth" }); // Scroll right by one card width 
      this.updateButtonStates(container);
    };

    container.addEventListener("scroll", () => this.updateButtonStates(container));


    if (items && items.length > 0) {
      items.forEach(function (objItem, index) {
        // Create the elements based on the control type
        if (
          self.props.controlType === GenericCarousel.ControlTypes.Accessories
        ) {
          const productCardElement = createProductCard(objItem);
          container.appendChild(productCardElement);
        } else if (
          self.props.controlType === GenericCarousel.ControlTypes.Default
        ) {
          const link = document.createElement("a");
          link.href = objItem.link.url
            ? objItem.link.url
            : objItem.link.document
            ? objItem.link.document.url
            : "#";
          link.target = objItem.link.openInNewWindow ? "_blank" : "";
          link.className = "post-card product-card-new related-documents";
          // if(isMobileView){
          //   const screenWidth = window.innerWidth; 
          //   const calculatedWidth = screenWidth * 0.6;
          //   link.style.minWidth = `${calculatedWidth}px`;
          // }else{

          //   link.style.minWidth = "500px";
          // }
          // link.style.minWidth = "500px";
          if(isMobileView){
            link.style.minWidth = "245px";
          }else{
            link.style.minWidth = "371px";
          }
          var deviceWidthForTile = window.innerWidth;

          if(deviceWidthForTile>=500 && deviceWidthForTile<=600){
            link.style.minWidth = "334px";
          }

          if(deviceWidthForTile>=710 && deviceWidthForTile<=825){
            link.style.minWidth = "270px";
          }
          if(deviceWidthForTile>=826 && deviceWidthForTile<=950){
            link.style.minWidth = "335px";
          }
          if(deviceWidthForTile>=951 && deviceWidthForTile<=1125){
            link.style.minWidth = "371px";
          }
          // console.log(deviceWidthForTile);
          

          const postCardInner = document.createElement("div");
          postCardInner.className = "post-card-inner";

          const postCardHead = document.createElement("div");
          postCardHead.className = "post-card-head";

          const postCat = document.createElement("h6");
          postCat.className = "post-cat";
          postCat.textContent = "Learn More";//objItem.eyebrow;
          postCardHead.appendChild(postCat);

          const imgElement = document.createElement("img");
          imgElement.className = "image-icon-product-detail";
          imgElement.src = objItem.icon ? objItem.icon?.url : objItem.image.url;
          imgElement.alt = objItem.eyebrow;
          postCardHead.appendChild(imgElement);

          postCardInner.appendChild(postCardHead);

          const postCardTitle = document.createElement("h3");
          postCardTitle.className = "post-card-title";
          postCardTitle.textContent = objItem.title;

          postCardInner.appendChild(postCardTitle);

          const postCardAction = document.createElement("div");
          postCardAction.className = "post-card-action";

          const icon = document.createElement("i");
          icon.className = "icon icon-direction-right";
          postCardAction.appendChild(icon);

          postCardInner.appendChild(postCardAction);

          link.appendChild(postCardInner);
          container.appendChild(link);
        }
      });
    } else {
      return null;
    }

    // Append left button, container (with cards), and right button to the wrapper
    wrapper.appendChild(scrollLeft);
    wrapper.appendChild(container);
    wrapper.appendChild(scrollRight);

    return wrapper;
    
    // Initial button state update
    this.updateButtonStates(container);
}};
 updateButtonStates = (container) => {
  const maxScrollLeft = container.scrollWidth - container.clientWidth;
  const scrollLeftButton = document.querySelector(".doc-left");
  const scrollRightButton = document.querySelector(".doc-right");

  // Enable/disable buttons based on scroll position
  scrollLeftButton.disabled = container.scrollLeft === 0;
  scrollRightButton.disabled = container.scrollLeft >= maxScrollLeft;
};
getGenericCardList = () => {
  let items = this.props.cards;
  let self = this;
  if (items && items.length > 0) {
    return items.map(function (objItem, index) {
      return (
        // <div key={index} className="post-carousel-item">
        <>
          {self.props.controlType ==
            GenericCarousel.ControlTypes.Accessories && (
            <ProductCard  product={objItem}></ProductCard>
          )}
          {self.props.controlType == GenericCarousel.ControlTypes.Default && (
            <a
              href={
                objItem.link.url
                  ? objItem.link.url
                  : objItem.link.document
                  ? objItem.link.document.url
                  : "#"
              }
              target={objItem.link.openInNewWindow ? "_blank" : ""}
              className="post-card product-card-new"
            >
              <div className="post-card-inner">
                <div className="post-card-head">
                  <h6 className="post-cat">{objItem.eyebrow}</h6>
                  <ImageBlock
                    image={objItem.icon ? objItem.icon : objItem.image}
                    addWrapper={false}
                  />
                </div>
                <h3 className="post-card-title">{objItem.title}</h3>
                <div className="post-card-action">
                  <i className="icon icon-direction-right"></i>
                </div>
              </div>
            </a>
          )}
        </>
      );
    });
  } else return null;
};


  nextSlide() {
    this.refs.slider.slickNext();
  }
  prevSlide() {
    this.refs.slider.slickPrev();
  }
  setStateForActiveSlides = (currentIndex, slideToShow) => {
    this.setState({
      isFirstSlide: currentIndex == 0,
      isLastSlide: currentIndex == this.props.cards.length - slideToShow,
    });
  };
  isAccessoryCtrl = () => {
    return this.props.controlType == GenericCarousel.ControlTypes.Accessories;
  };
  getSliderSettings = () => {
    var self = this;
    var slideToShow = self.isAccessoryCtrl() ? 3 : 2;
    return {
      className: "post-carousel-items",
      slidesToShow: slideToShow,
      slidesToScroll: 1,
      swipeToSlide: true,
      infinite: false,
      dots: false,
      afterChange: function (index) {
        self.setStateForActiveSlides(index, slideToShow);
      },
      arrows: false,
      responsive: [
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            dots: true,
            afterChange: function (index) {
              self.setStateForActiveSlides(index, 2);
            },
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            afterChange: function (index) {
              self.setStateForActiveSlides(index, 2);
            },
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            afterChange: function (index) {
              self.setStateForActiveSlides(index, 1);
            },
          },
        },
      ],
    };
  };
  getSliderButtons = () => {
    var slideToShow = this.isAccessoryCtrl() ? 4 : 3;
    if (this.props.cards && this.props.cards.length > slideToShow) {
      return (
        <>
          <a
            onClick={() => {
              this.prevSlide();
            }}
            className={
              "btn btn-circle" + (this.state.isFirstSlide ? " disabled" : "")
            }
          >
            <i className="icon icon-prev"></i>
          </a>
          <a
            onClick={() => {
              this.nextSlide();
            }}
            className={
              "btn btn-circle" + (this.state.isLastSlide ? " disabled" : "")
            }
          >
            <i className="icon icon-next"></i>
          </a>
        </>
      );
    } else return null;
  };

  handlePrev = (controlType) => {
    if (this.sliderRef.current) {
      this.sliderRef.current.scrollBy({ left: -384, behavior: "smooth" });
    }
    const { currentIndex } = this.state;
    if (currentIndex > 0) {
      this.setState({ currentIndex: currentIndex - 1 });
  
      // const slider = this.sliderRef.current;
      // slider.scrollBy({
      //   top: 0,
      //   left: -150,
      //   behavior: 'smooth'
      // });
    }
    if(controlType !=
      GenericCarousel.ControlTypes.Accessories){
        setTimeout(()=>{
          const element = document.getElementById("documentsCardList")
          ReactDOM.render(this.getAccesoriesOrDocuments(), element);
            },20);
    }
  
    // Remove the 'active' class from elements with the specific class name
    const elements = document.getElementsByClassName(
      'product-card product-card-new active colorflex-l2-accessory-card accessory-card-product'
    );
  
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].classList.contains('active')) {
        elements[i].classList.remove('active');
      }
    }
  };
  


  handleNext = (controlType) => {
    const { currentIndex, isMobileView } = this.state;
  
    // Smooth scroll the slider
    if (this.sliderRef.current) {
      this.sliderRef.current.scrollBy({ left: 384, behavior: "smooth" });
    }
  
    // Update the currentIndex state
    let items = this.props.cards;
    let totalItems = items.length;
    let maxIndex = isMobileView ? totalItems - 1 : totalItems - 3;
  
    if (currentIndex < maxIndex) {
      this.setState({ currentIndex: currentIndex + 1 });
    }
    if(controlType !=
      GenericCarousel.ControlTypes.Accessories){
        setTimeout(()=>{
      const element = document.getElementById("documentsCardList")
      ReactDOM.render(this.getAccesoriesOrDocuments(), element);
        },20);
    }
  
    // Remove the 'active' class from elements with the specific class name
    const elements = document.getElementsByClassName(
      'product-card product-card-new active colorflex-l2-accessory-card accessory-card-product'
    );
  
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].classList.contains('active')) {
        elements[i].classList.remove('active');
      }
    }
  };

  getAccesoriesOrDocuments = () => {
    let items = this.props.cards;
    const {  currentIndex,isMobileView } = this.state;
    const deviceWidth = window.innerWidth;

    var visibleImages = !isMobileView ? items.slice(currentIndex, currentIndex + 3) : items.slice(currentIndex, currentIndex+1);
    if(deviceWidth>=710 && deviceWidth<=1200){
      visibleImages = !isMobileView ? items.slice(currentIndex, currentIndex + 2) : items.slice(currentIndex, currentIndex+1);
    }
    if(deviceWidth>=500 && deviceWidth<=709){
      visibleImages = !isMobileView ? items.slice(currentIndex, currentIndex + 1) : items.slice(currentIndex, currentIndex+1);
    }
    let totalItems = items.length;
    let maxIndex = isMobileView ? totalItems - 1 : totalItems - 3;
  
    let self = this;
    if (items && items.length > 0) {
      return (
        <div style={{display:"flex", gap:"10px", alignItems:"center"}}>
          <button onClick={()=>this.handlePrev(self.props.controlType)} className="arrow-left button-arrow" disabled={currentIndex==0}>
              &#10094;
            </button>
            <div ref={this.sliderRef} className="slider-item-container">

          {visibleImages.map((objItem, index) =>{
            return (
              // <div key={index} className="post-carousel-item">
              <div  key={index} className="carousel-Items">
                {self.props.controlType ==
                  GenericCarousel.ControlTypes.Accessories && (
                <ProductCard isaccesossoryCard={true} product={objItem}></ProductCard>
                )}
                {self.props.controlType ==
                  GenericCarousel.ControlTypes.Default && (
                  <a
                    href={
                      objItem.link.url
                        ? objItem.link.url
                        : objItem.link.document
                        ? objItem.link.document.url
                        : "#"
                    }
                    target={objItem.link.openInNewWindow ? "_blank" : ""}
                    className="post-card product-card-new"
                  >
                    <div className="post-card-inner">
                      <div className="post-card-head">
                        <h6 className="post-cat">{objItem.eyebrow}</h6>
                        <ImageBlock
                          image={objItem.icon ? objItem.icon : objItem.image}
                          addWrapper={false}
                        />
                      </div>
                      <h3 className="post-card-title">{objItem.title}</h3>
                      <div className="post-card-action">
                        <i className="icon icon-direction-right"></i>
                      </div>
                    </div>
                  </a>
                )}
              </div>
            );
          })}
            </div>

           <button onClick={()=>this.handleNext(self.props.controlType)} className="arrow-right button-arrow"
            disabled={currentIndex >= maxIndex}
            >
              &#10095;
            </button>
        </div>
      );
    } else return null;
  };

  getAccessoriesData = () => {
    this.setState({ isDocuments: false });
  };
  getDocumentsData = () => {
    this.setState({ isDocuments: true });
  };

  openOthers = (tabId) => {
    // Hide all tab content
    if (this.state.activeOthers !== tabId) {
      this.setState({ activeOthers: tabId });
    }
    this.props.controlType === GenericCarousel.ControlTypes.Default ?  this.getGenericDocumentCardList() : null
  };
  render() {
    const { activeOthers } = this.state;
    let isColorFlexL2 = window.location.pathname.includes("colorflex-l2");
    if(isColorFlexL2){
    return !window.location.pathname.includes("product") ? (
      <div className={"post-carousel-section " + this.props.controlType}>
        <div className="container">
          <div className="post-carousel border-none-mobile">
            <div className="post-carousel-head">
              <div className="post-info post-info-tiles-new">
                {!this.isAccessoryCtrl() && this.props.eyebrow && (
                  <h2 className="hunterlab-title post-info-title">
                    {this.props.eyebrow}
                  </h2>
                )}
                <div className="post-info-desc">
                  <SafeHTML>
                    {this.isAccessoryCtrl()
                      ? this.props.eyebrow
                      : this.props.description}
                  </SafeHTML>
                  <div
                    id="documentsCardList"
                    className="post-info-desc product-category"
                  >
                    {this.getGenericCardList(-1)}
                  </div>
                </div>
              </div>
              {/* <div className="post-info-action">{this.getSliderButtons()}</div> */}
            </div>
            {/* <Slider ref="slider" {...this.getSliderSettings()}> */}
            {/* {this.getGenericCardList()} */}
            {/* </Slider> */}
          </div>
        </div>
      </div>
    ) : (
      <div id="product-detail-others-section">
        {this.isAccessoryCtrl() && (
          <>
            <div className={"post-carousel-section " + this.props.controlType}>
              <div class="accessories-documents-tab-content">
                <div className="container" >
                <div  id={`accessories`}  className={`tab-pane ${ activeOthers === "accessories" ? "active" : "" }`}>
                      {this.getAccesoriesOrDocuments()}
                </div>
                </div>
                <div
                  id={`documents`}
                  className={`tab-pane ${
                    activeOthers === "documents" ? "active" : ""
                  }`}
                >
                    {this.props.eyebrow=="Accessories" && <div  id="documentsCardList" className="product-document-category container"
                    >
                    </div>}
                  </div>


                  <div style={{width:"fit-content", marginInline:"auto", marginTop:"20px"}}>
                  {this.props.eyebrow=="Accessories" ? <div>
                  { (window.location.pathname.includes("colorflex-l2") && window.location.pathname.includes("/es/")) ? 
                  <h2 className="app-info-title" style={{textAlign:"center"}}>Artículos <span style={{ color: "#428BC5" }}>esenciales</span></h2>
                  :
                  <h2 className="app-info-title" style={{textAlign:"center"}}>Essential <span style={{ color: "#428BC5" }}>Items</span></h2>
                  }
                  
                <div className="accessories-documents-tabs">


                  <button
                    className={`tab-button-product-detail ${
                      activeOthers === `accessories` ? "active" : ""
                    }`}
                    onClick={() => this.openOthers(`accessories`)}
                    style={{ backgroundColor: "transparent", border: "none" }}
                  >
                    <img src={AccessoriesIcon} alt="AccessoriesIcon" />{" "}
                    { (window.location.pathname.includes("colorflex-l2") && window.location.pathname.includes("/es/")) ? 
                  <span>Accesorios</span>
                  :
                  <span>Accessories</span>
                  }
                    
                  </button>
                  <button
                    className={`tab-button-product-detail ${
                      activeOthers === `documents` ? "active" : ""
                    }`}
                    onClick={() => this.openOthers(`documents`)}
                    style={{ backgroundColor: "transparent", border: "none" }}
                  >
                    <img src={DocumentsIcon} alt="DocumentsIcon" />
                    { (window.location.pathname.includes("colorflex-l2") && window.location.pathname.includes("/es/")) ? 
                  <span>Documentos</span>
                  :
                  <span>Documents</span>
                  }
                  </button>
                </div>
                </div>
                :
                <div>
                  { (window.location.pathname.includes("colorflex-l2") && window.location.pathname.includes("/es/")) ? 
                  <h2 className="app-info-title" style={{textAlign:"center"}}>Contenido <span style={{ color: "#428BC5" }}>de la caja</span></h2>
                  :
                  <h2 className="app-info-title" style={{textAlign:"center"}}>What's <span style={{ color: "#428BC5" }}>in the Box</span></h2>
                  }
                  { (window.location.pathname.includes("colorflex-l2") && window.location.pathname.includes("/es/")) ? 
                  <p className="whats-in-the-box-sub-text">¡Todo lo que necesita para una medición precisa del color en cuestión de minutos!</p>
                  :
                  <p className="whats-in-the-box-sub-text">All you need to get accurate color measurement in minutes!</p>
                  }
                </div>}

                </div>

                
              </div>
            </div>
          </>
        )}
      </div>
    );
  }else{
    return (
      <div className={"post-carousel-section " + this.props.controlType}>
        <div className="container">
          <div className="post-carousel border-none-mobile">
            <div className="post-carousel-head">
              <div className="post-info post-info-tiles-new">
                {!this.isAccessoryCtrl() && this.props.eyebrow && (
                  <h2 className="hunterlab-title post-info-title">
                    {this.props.eyebrow}
                  </h2>
                )}
                <div className="post-info-desc">
                  <SafeHTML>
                    {this.isAccessoryCtrl()
                      ? this.props.eyebrow
                      : this.props.description}
                  </SafeHTML>
                  <div className="post-info-desc product-category">
                    {this.getGenericCardList(-1)}
                  </div>
                </div>
              </div>
              {/* <div className="post-info-action">{this.getSliderButtons()}</div> */}
            </div>
            {/* <Slider ref="slider" {...this.getSliderSettings()}> */}
              {/* {this.getGenericCardList()} */}
            {/* </Slider> */}
          </div>
        </div>
      </div>
    );

  }
  }
}
